module.exports = __webpack_public_path__ + "c4f31f70d4d199e0777e342763346155.png";


//////////////////
// WEBPACK FOOTER
// ./js/index/img/about-3.png
// module id = 6
// module chunks = 0